export const hasCompanyDataCompleted = (profile = {}) =>
  Boolean(profile?.userInfo?.address?.written_address?.trim())

export const normalizeCompanyContactSignature = (value) => {
  if (value == null) return ''
  if (typeof value === 'number') return String(value).trim()
  if (typeof value !== 'string') return ''

  const normalized = value.trim()
  const compact = normalized.replace(/[\s"'`]/g, '').toUpperCase()
  if (compact === '{FIRMA}' || compact === 'FIRMA') return ''
  return normalized
}

export const isCompanyContractSigned = (signatureValue) =>
  Boolean(normalizeCompanyContactSignature(signatureValue))

// The backend's contract_signature_status.name is the source of truth once
// present — the companyContactSignature placeholder heuristic is only a
// fallback for older contracts that don't carry that status yet.
export const isContractFullySigned = (contract) => {
  const statusName = contract?.contract_signature?.contract_signature_status?.name
  if (typeof statusName === 'string' && statusName.trim()) {
    return statusName.trim() === 'Firmado'
  }

  return isCompanyContractSigned(
    contract?.contract_signature?.references?.companyContactSignature
  )
}

export const ONBOARDING_STEP = {
  PROFILE: 'profile',
  SIGNING: 'signing',
  CONTRACT: 'contract',
}

export const getCompanyOnboardingState = (profile = {}, contracts = []) => {
  const profileComplete = hasCompanyDataCompleted(profile)
  // A company can have more than one contract — prefer an already-signed
  // one over the raw first item, since the signed one isn't guaranteed to
  // be first in the list the backend returns.
  const relevantContract =
    contracts.find(isContractFullySigned) ?? contracts[0] ?? null
  const contractSigned = isContractFullySigned(relevantContract)

  if (!profileComplete) {
    return { phase: 1, maxSteps: 1, contractSigned: false }
  }

  if (!contractSigned) {
    return { phase: 2, maxSteps: 2, contractSigned: false }
  }

  return { phase: 3, maxSteps: 3, contractSigned: true }
}

export const mapProfileToCompanyForm = (profile = {}) => {
  const userInfo = profile?.userInfo ?? {}
  const address = userInfo?.address ?? {}

  return {
    company: {
      name: userInfo.name ?? '',
      displayName: userInfo.display_name ?? '',
      nif: userInfo.nif ?? userInfo.rep_dni ?? userInfo.contact_dni ?? '',
      vat: userInfo.vat ?? '',
      bankAccount:
        userInfo.sepa_number ?? userInfo.bank_account ?? userInfo.bankAccount ?? '',
      email: userInfo.user?.email ?? '',
      phone: userInfo.phone ?? '',
      website: userInfo.website ?? '',
      legalContactName:
        userInfo.legal_contact_name ?? userInfo.rep_name ?? '',
      legalContactDni:
        userInfo.legal_contact_dni ?? userInfo.rep_dni ?? userInfo.contact_dni ?? '',
    },
    address: {
      street: address.written_address ?? '',
      city: address.city?.id ?? '',
      postalCode: address.zip_code ?? '',
      country: address.country?.id ?? '',
      state: address.state?.id ?? '',
    },
  }
}
